import { createFileRoute, Outlet } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'

export const Route = createFileRoute('/onboarding/_route-wapper')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  )
}
